import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { EmpresasBloqueadasComponent } from './empresas-bloqueadas.component';
import { ExportacaoRoutingModule } from './exportacao-routing.module';
import { SolicitacoesHonraExportacaoComponent } from './solicitacoes-honra-exportacao.component';
import { ExportacaoParametrosComponent } from './exportacao-parametros.component';


@NgModule({
  imports: [
    SharedModule,
    ExportacaoRoutingModule,
  ],
  declarations: [
    ExportacaoParametrosComponent,
    EmpresasBloqueadasComponent,
    SolicitacoesHonraExportacaoComponent
  ]
})
export class ExportacaoModule { }
